import { LocalViewsProvider } from "@on-site/features/top/providers/LocalViewsProvider";
import { ComponentProps, FC } from "react";

export const withLocalViews = (Component: FC) => {
  return (props: ComponentProps<typeof Component>) => {
    return (
      <LocalViewsProvider>
        <Component {...props} />
      </LocalViewsProvider>
    );
  };
};
